// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/Previous.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/Next.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../images/PreviousDisabled.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/NextDisabled.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carousel-wrap {
  margin: auto !important;
  position: relative !important;
}
.owl-carousel .owl-nav {
  overflow: hidden !important;
  height: 0px !important;
}

.owl-theme .owl-dots .owl-dot.active span,
.owl-theme .owl-dots .owl-dot:hover span {
  background: #2caae1 !important;
}
.owl-theme {
  margin-top: 12px;
}

.owl-carousel .item {
  text-align: center !important;
}
.owl-carousel .nav-btn {
  height: 30px !important;
  position: absolute !important;
  width: 26px !important;
  cursor: pointer !important;
  top: 50%;
  transform: translateY(-50%);
}

.owl-carousel .owl-prev.disabled,
.owl-carousel .owl-next.disabled {
  pointer-events: none !important;
  opacity: 1 !important;
}

.owl-carousel .prev-slide {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat scroll !important;
  left: -18px !important;
}
.owl-carousel .next-slide {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat scroll !important;
  right: -28px !important;
}

.owl-carousel .disabled .prev-slide {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat scroll !important;
  left: -18px !important;
}
.owl-carousel .disabled .next-slide {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat scroll !important;
  right: -28px !important;
}

span.img-text {
  text-decoration: none !important;
  cursor: pointer !important;
  width: 100% !important;
  font-size: 23px !important;
  display: block !important;
  text-transform: capitalize !important;
}
span.img-text:hover {
  color: #2caae1 !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/carousel-custom.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;;EAEE,8BAA8B;AAChC;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;EACtB,0BAA0B;EAC1B,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;;EAEE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,+EAAmE;EACnE,sBAAsB;AACxB;AACA;EACE,+EAA+D;EAC/D,uBAAuB;AACzB;;AAEA;EACE,+EAA2E;EAC3E,sBAAsB;AACxB;AACA;EACE,+EAAuE;EACvE,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,sBAAsB;EACtB,0BAA0B;EAC1B,yBAAyB;EACzB,qCAAqC;AACvC;AACA;EACE,yBAAyB;AAC3B","sourcesContent":[".carousel-wrap {\r\n  margin: auto !important;\r\n  position: relative !important;\r\n}\r\n.owl-carousel .owl-nav {\r\n  overflow: hidden !important;\r\n  height: 0px !important;\r\n}\r\n\r\n.owl-theme .owl-dots .owl-dot.active span,\r\n.owl-theme .owl-dots .owl-dot:hover span {\r\n  background: #2caae1 !important;\r\n}\r\n.owl-theme {\r\n  margin-top: 12px;\r\n}\r\n\r\n.owl-carousel .item {\r\n  text-align: center !important;\r\n}\r\n.owl-carousel .nav-btn {\r\n  height: 30px !important;\r\n  position: absolute !important;\r\n  width: 26px !important;\r\n  cursor: pointer !important;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n}\r\n\r\n.owl-carousel .owl-prev.disabled,\r\n.owl-carousel .owl-next.disabled {\r\n  pointer-events: none !important;\r\n  opacity: 1 !important;\r\n}\r\n\r\n.owl-carousel .prev-slide {\r\n  background: url(../images/Previous.svg) no-repeat scroll !important;\r\n  left: -18px !important;\r\n}\r\n.owl-carousel .next-slide {\r\n  background: url(../images/Next.svg) no-repeat scroll !important;\r\n  right: -28px !important;\r\n}\r\n\r\n.owl-carousel .disabled .prev-slide {\r\n  background: url(../images/PreviousDisabled.svg) no-repeat scroll !important;\r\n  left: -18px !important;\r\n}\r\n.owl-carousel .disabled .next-slide {\r\n  background: url(../images/NextDisabled.svg) no-repeat scroll !important;\r\n  right: -28px !important;\r\n}\r\n\r\nspan.img-text {\r\n  text-decoration: none !important;\r\n  cursor: pointer !important;\r\n  width: 100% !important;\r\n  font-size: 23px !important;\r\n  display: block !important;\r\n  text-transform: capitalize !important;\r\n}\r\nspan.img-text:hover {\r\n  color: #2caae1 !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
